import React from 'react';

const NebulaHoldingsFormModal = React.lazy(() => import('../components/FormModal'));
const nebulaHoldingsModalRegistry = {
    personalize_nebulaHoldingsId: NebulaHoldingsFormModal
};
export default nebulaHoldingsModalRegistry;
